<template>
  <div>
    <div>
      <div class="card card-default">
        <div class="card-header">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <a class="btn btn-secondary" tabindex="-1" @click="showCreateTokenForm">
              Create New Token
            </a>
          </div>
        </div>

        <div class="card-body">
          <!-- No Tokens Notice -->
          <p v-if="tokens.length === 0" class="mb-0">
            You have not created any personal access tokens.
          </p>

          <!-- Personal Access Tokens -->
          <table v-if="tokens.length > 0" class="table mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th />
              </tr>
            </thead>

            <tbody>
              <tr v-for="(token, index) in tokens" :key="index">
                <!-- Client Name -->
                <td style="vertical-align: middle;">
                  {{ token.name }}
                </td>

                <!-- Delete Button -->
                <td style="vertical-align: middle;">
                  <a class="action-link text-ss-danger" @click="revoke(token)">
                    Delete
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Create Token Modal -->
    <vjs-modal :name="modals.create_token" title="Create Token" icon="la la-plus-circle">
      <form id="create-token-form" role="form" @submit.prevent="store">
        <div class="form-group row">
          <label for="token-name">Name:</label>
          <input v-model="form.name" name="token-name"
                 type="text"
                 class="form-control">
        </div>

        <!-- Scopes -->
        <div v-if="scopes.length > 0" class="form-group row">
          <label class="col-md-4 col-form-label">Scopes</label>

          <div class="col-md-6">
            <div v-for="(scope, index) in scopes" :key="index">
              <ss-checkbox :id="scope.id" :checked="scopeIsAssigned(scope.id)" @click="toggleScope(scope.id)">
                {{ scope.id }}
              </ss-checkbox>
            </div>
          </div>
        </div>
      </form>

      <template slot="body-controls">
        <b-button variant="ss-standout" type="submit" form="create-token-form">
          Create
        </b-button>
        <b-button variant="ss" type="button" @click="$modal.hide(`create-token`)">
          Cancel
        </b-button>
      </template>
    </vjs-modal>

    <!-- Access Token Modal -->
    <vjs-modal :name="modals.show_token" title="Personal Access Token" icon="la la-key">
      <p>
        Here is your new personal access token. This is the only time it will be shown so don't lose it! You may now use this token to make API requests.
      </p>

      <textarea v-model="access_token" class="form-control" rows="10" />

      <template slot="body-controls">
        <b-button variant="ss-standout" @click="() => copyValueToClipboard(access_token)">
          Copy to Clipboard
        </b-button>
        <b-button variant="ss" @click="$modal.hide(`show-token`)">
          Close
        </b-button>
      </template>
    </vjs-modal>
  </div>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import { copyValueToClipboard } from 'Helpers/misc';

export default {
  components: {
    VjsModal,
  },
  data() {
    return {
      modals: {
        create_token: `create-token`,
        show_token: `show-token`,
      },
      access_token: null,
      tokens: [],
      scopes: [],
      form: {
        name: '',
        scopes: [],
        errors: [],
      },
    };
  },
  mounted() {
    this.prepareComponent();
  },
  methods: {
    copyValueToClipboard,
    /**
		 * Prepare the component.
		 */
    prepareComponent() {
      this.getTokens();
      this.getScopes();
    },

    /**
		 * Get all of the personal access tokens for the user.
		 */
    getTokens() {
      axios.get('/oauth/personal-access-tokens').then((response) => {
        this.tokens = response.data;
      });
    },

    /**
		 * Get all of the available scopes.
		 */
    getScopes() {
      axios.get('/oauth/scopes').then((response) => {
        this.scopes = response.data;
      });
    },

    /**
		 * Show the form for creating new tokens.
		 */
    showCreateTokenForm() {
      this.$modal.show(this.modals.create_token);
    },

    /**
		 * Create a new personal access token.
		 */
    store() {
      this.$modal.hide(this.modals.create_token);
      this.access_token = null;
      this.form.errors = [];

      axios
        .post('/oauth/personal-access-tokens', this.form)
        .then((response) => {
          this.form.name = '';
          this.form.scopes = [];
          this.form.errors = [];

          this.getTokens();
          this.showAccessToken(response.data.accessToken);
        })
        .catch((error) => {
          if (typeof error.response.data === 'object') {
            this.form.errors = _.flatten(_.toArray(error.response.data.errors));
          } else {
            this.form.errors = ['Something went wrong. Please try again.'];
          }
        });
    },

    /**
		 * Toggle the given scope in the list of assigned scopes.
		 */
    toggleScope(scope) {
      if (this.scopeIsAssigned(scope)) {
        this.form.scopes = _.reject(this.form.scopes, s => s == scope);
      } else {
        this.form.scopes.push(scope);
      }
    },

    /**
		 * Determine if the given scope has been assigned to the token.
		 */
    scopeIsAssigned(scope) {
      return _.indexOf(this.form.scopes, scope) >= 0;
    },

    /**
		 * Show the given access token to the user.
		 */
    showAccessToken(access_token) {
      this.access_token = access_token;
      this.$modal.show(this.modals.show_token);
    },

    /**
		 * Revoke the given token.
		 */
    revoke(token) {
      axios
        .delete('/oauth/personal-access-tokens/' + token.id)
        .then(() => {
          this.getTokens();
        });
    },
  },
};
</script>

<style scoped>
.action-link {
	cursor: pointer;
}
</style>
